export default "__VITE_ASSET__pWPlI6QX__"